import { useEffect } from "react";
import Header from "../../components/StudentPortal/Header/Header";
import LeaderboardComponent from "../../components/StudentPortal/LeaderBoard/Leaderboard";

export default function Leaderboard() {
  useEffect(() => {
    document.title = "Leaderboard - LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <section className="py-6 bg-primary">
        <LeaderboardComponent />
      </section>
    </>
  );
}
